import React from 'react';

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}

class ContactForm extends React.Component {
  state = {
    full_name: null,
    email: null,
    phone: null,
    message: null,
    audit: null
  };

  handleChange = data => {
    this.setState({ [data.target.name]: data.target.value });
  };

  handleSubmit = e => {
    e.preventDefault();
    const form = e.target;
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': form.getAttribute('name'),
        ...this.state
      })
    })
      .then(() => {
        document.getElementById('contact_form').reset();
        this.setState({ submitted: true, error: false });
      })
      .catch(error => {
        document.getElementById('contact_form').reset();
        this.setState({ submitted: true, error: true });
      });
  };

  render() {
    //console.log(this.state);

    const submitted = this.state.submitted;
    const error = this.state.error;

    return (
      <div className="relative bg-white">
        <div className="relative max-w-7xl mx-auto lg:grid lg:grid-cols-5">
          <div className="py-8 px-4 sm:px-6 lg:col-span-2 lg:px-8 lg:py-24 xl:pr-12">
            <div className="max-w-lg mx-auto">
              <dl className="mt-8 text-base leading-6 text-gray-500">
                <div>
                  <dt className="sr-only">Postal address</dt>
                  <dd>
                    <p>1659 Achieva Way</p>
                    <p class="-mt-4">Dunedin, FL 34698</p>
                  </dd>
                </div>
                <div className="mt-6">
                  <dt className="sr-only">Phone number</dt>
                  <dd className="flex">
                    <svg
                      className="flex-shrink-0 h-6 w-6 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      viewBox="0 0 24 24"
                    >
                      <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>

                    <a href="tel:8883417735" className="hover:underline text-sm font-light ml-3">
                      +1 (888) 341-7735
                    </a>
                  </dd>
                </div>
                <div className="mt-3">
                  <dt className="sr-only">Email</dt>
                  <dd className="flex">
                    <svg
                      className="flex-shrink-0 h-6 w-6 text-gray-400"
                      stroke="currentColor"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                    <span className="ml-3">marketing@consultfgc.com</span>
                  </dd>
                </div>
              </dl>
            </div>
          </div>

          <div className="bg-white py-6 px-4 sm:px-6 lg:col-span-3 lg:py-24 lg:px-8 xl:pl-12">
            <div className="max-w-lg mx-auto lg:max-w-none">
              {submitted === true ? (
                <div>
                  {error === true ? (
                    <h1>If error is true display top and thiss</h1>
                  ) : (
                    <div className="text-center lg:text-center">
                      <h2 className=" text-6xl text-gray-600 font-bold leading-none">THANK YOU!</h2>

                      <svg
                        class="mt-4 mx-auto"
                        fill="#1db33d"
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                      >
                        <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
                      </svg>

                      <h2 className="text-2xl lg:text-3xl text-gray-700 pt-4 font-regular leading-tight">
                        We've received your message and we'll get back to you within 24 hours.
                      </h2>
                    </div>
                  )}
                </div>
              ) : (
                <form
                  id="contact_form"
                  name="contact"
                  method="POST"
                  data-netlify="true"
                  data-netlify-honeypot="bot-field"
                  onSubmit={this.handleSubmit}
                  className="grid grid-cols-1 row-gap-6"
                >
                  <div>
                    <label for="full_name" className="sr-only">
                      Full name
                    </label>

                    <div className="relative rounded-md shadow-sm">
                      <input
                        id="full_name"
                        name="full_name"
                        onChange={this.handleChange}
                        required
                        className="form-input block w-full py-3 px-4 placeholder-gray-500 transition ease-in-out duration-150"
                        placeholder="Full name"
                      />
                    </div>
                  </div>

                  <div>
                    <label for="email" className="sr-only">
                      Email
                    </label>

                    <div className="relative rounded-md shadow-sm">
                      <input
                        id="email"
                        name="email"
                        onChange={this.handleChange}
                        required
                        type="email"
                        className="form-input block w-full py-3 px-4 placeholder-gray-500 transition ease-in-out duration-150"
                        placeholder="Email"
                      />
                    </div>
                  </div>

                  <div>
                    <label for="phone" className="sr-only">
                      Phone
                    </label>

                    <div className="relative rounded-md shadow-sm">
                      <input
                        id="phone"
                        name="phone"
                        onChange={this.handleChange}
                        type="phone"
                        className="form-input block w-full py-3 px-4 placeholder-gray-500 transition ease-in-out duration-150"
                        placeholder="Phone"
                      />
                    </div>
                  </div>

                  <div>
                    <label for="phone" className="sr-only">
                      Audit
                    </label>

                    <div className="relative rounded-md shadow-sm">
                      <input
                        id="audit"
                        name="audit"
                        onChange={this.handleChange}
                        type="text"
                        className="form-input block w-full py-3 px-4 placeholder-gray-500 transition ease-in-out duration-150"
                        placeholder="Please audit my website - www.yourcompany.com"
                      />
                    </div>
                  </div>

                  <div>
                    <label for="message" className="sr-only">
                      Message
                    </label>

                    <div className="relative rounded-md shadow-sm">
                      <textarea
                        id="message"
                        name="message"
                        onChange={this.handleChange}
                        required
                        rows="4"
                        className="form-input block w-full py-3 px-4 placeholder-gray-500 transition ease-in-out duration-150"
                        placeholder="Message"
                      ></textarea>
                    </div>
                  </div>

                  <span className="inline-flex rounded-md">
                    <button
                      type="submit"
                      className="focus:outline-none bg-blue-600 rounded-full text-white tracking-wider inline-flex items-center px-24 py-4 text-sm leading-4 hover:bg-blue-500 transition ease-in-out duration-500 "
                    >
                      Submit
                    </button>
                  </span>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactForm;
